import { faTrophy, faWifi } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Image } from 'react-bootstrap';
import confetti from 'canvas-confetti';

const mensajesPrueba = [
  { id: crypto.randomUUID(), nombre: 'Ana Martínez',      ppm: 285, comprension: 94, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Carlos Ramírez',    ppm: 312, comprension: 91, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Sofía Hernández',   ppm: 267, comprension: 97, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Luis Fernández',    ppm: 340, comprension: 89, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Valeria Gómez',     ppm: 298, comprension: 96, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Miguel Torres',     ppm: 255, comprension: 93, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Fernanda Cruz',     ppm: 321, comprension: 95, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Jorge Mendoza',     ppm: 276, comprension: 88, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Andrea Ruiz',       ppm: 305, comprension: 98, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Daniel Castro',     ppm: 288, comprension: 90, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Paola Navarro',     ppm: 350, comprension: 92, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Ricardo Morales',   ppm: 264, comprension: 94, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Natalia Flores',    ppm: 315, comprension: 99, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Alejandro Silva',   ppm: 290, comprension: 87, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Camila Ortega',     ppm: 334, comprension: 96, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Diego Reyes',       ppm: 271, comprension: 91, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Mariana López',     ppm: 325, comprension: 97, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'José Aguilar',      ppm: 282, comprension: 89, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Gabriela Castillo', ppm: 308, comprension: 95, fecha: Date.now() },
  { id: crypto.randomUUID(), nombre: 'Emilio Vargas',     ppm: 345, comprension: 93, fecha: Date.now() },
];

// const lanzarConfetti = (fase) => {
//   if (fase === 3) {
//     // Gran final → efecto más espectacular: dos cañones desde los lados
//     const left  = () => confetti({
//       particleCount: 80,
//       angle: 60,
//       spread: 70,
//       origin: { x: 0, y: 0.75 },
//       colors: ['#ff9900', '#ffffff', '#FFD700'],
//     });
//     const right = () => confetti({
//       particleCount: 80,
//       angle: 120,
//       spread: 70,
//       origin: { x: 1, y: 0.75 },
//       colors: ['#ff9900', '#ffffff', '#FFD700'],
//     });

//     // Tres ráfagas con delay para que se sienta épico
//     left(); right();
//     setTimeout(() => { left(); right(); }, 400);
//     setTimeout(() => { left(); right(); }, 800);

//   } else {
//     // Fases 1 y 2 → lluvia central más discreta
//     confetti({
//       particleCount: 100,
//       spread: 70,
//       origin: { y: 0.6 },
//       colors: ['#ff9900', '#ffffff', '#00152a'],
//     });
//   }
// };

const lanzarConfetti = (fase) => {
   const left  = () => confetti({
      particleCount: 80,
      angle: 60,
      spread: 70,
      origin: { x: 0, y: 0.75 },
      colors: ['#ff9900', '#ffffff', '#FFD700'],
    });
    const right = () => confetti({
      particleCount: 80,
      angle: 120,
      spread: 70,
      origin: { x: 1, y: 0.75 },
      colors: ['#ff9900', '#ffffff', '#FFD700'],
    });

    // Tres ráfagas con delay para que se sienta épico
    left(); right();
    setTimeout(() => { left(); right(); }, 400);
    setTimeout(() => { left(); right(); }, 800);
};

// const handleCalificar = () => {
//   const top = [...mensajes]
//     .sort((a, b) => calcularIEL(b.ppm, b.comprension) - calcularIEL(a.ppm, a.comprension))
//     .slice(0, TOMAR);
//   setRanking(top);
//   setVista('resultados');
//   lanzarConfetti(fase);   // 👈 se dispara al mostrar resultados
// };

const calcularIEL = (ppm, comprension) => ppm * (comprension / 100);

const medalColor = { 0: '#FFD700', 1: '#C0C0C0', 2: '#CD7F32' };
const medalLabel = { 0: '🥇', 1: '🥈', 2: '🥉' };

// fase: 1 | 2 | 3
// vista: 'feed' | 'resultados'
// Fase 1 feed  → acumula 20, botón "Calificar" → Fase 1 resultados (top 10)
// Fase 2 feed  → acumula 10, botón "Calificar" → Fase 2 resultados (top 3 / podio)

const PanelFinalCompetenciaLectura = () => {
  const [fase, setFase]           = useState(1);
  const [vista, setVista]         = useState('feed');
  const [mensajes, setMensajes]   = useState([]);
  const [ranking, setRanking]     = useState([]);          // top10 o top3 según fase
  const [usuariosActivos, setUsuariosActivos] = useState(0);
  const [wsStatus, setWsStatus]   = useState('connecting');
  const feedRef = useRef(null);

  const META  = fase === 1 ? 20 : fase === 2 ? 10 : 3;
  const TOMAR = fase === 1 ? 10 : fase === 2 ? 3  : 3;  // cuántos se seleccionan al calificar
  const puedeCalificar = mensajes.length >= META;

  useEffect(() => {
    const ws = new WebSocket('wss://qawebsocket.globalclickmexico.com/ws');
    ws.onopen  = () => setWsStatus('open');
    ws.onclose = () => setWsStatus('closed');
    ws.onerror = () => setWsStatus('error');
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === 'activos') setUsuariosActivos(data.payload.text);
      if (data.type === 'message') {
        setMensajes(prev => [...prev, {
          id:          crypto.randomUUID(),
          nombre:      data.payload.nombre,
          ppm:         data.payload.ppm,
          comprension: data.payload.comprension,
          fecha:       data.payload.fecha,
        }]);
      }
    };
    return () => ws.close();
  }, []);

  useEffect(() => {
    if (feedRef.current) feedRef.current.scrollTop = feedRef.current.scrollHeight;
  }, [mensajes]);

  // Calificar: ordenar por IEL y tomar los mejores según la fase
  const handleCalificar = () => {
    const top = [...mensajes]
      .sort((a, b) => calcularIEL(b.ppm, b.comprension) - calcularIEL(a.ppm, a.comprension))
      .slice(0, TOMAR);
    setRanking(top);
    setVista('resultados');
     lanzarConfetti(fase);   // 👈 se dispara al mostrar resultados

  };

  // Pasar a la siguiente fase: limpiar mensajes y volver al feed
  const handleSiguienteFase = () => {
    setMensajes(ranking);
    setRanking([]);
     setFase(prev => prev + 1);   // 1→2, 2→3
    setVista('feed');
  };

  const statusLabel = {
    connecting: 'Conectando al servidor',
    open:       'Conectado · globalclickmexico.com',
    closed:     'Conexión cerrada',
    error:      'Error de conexión',
  }[wsStatus];

  const tituloResultados =
  fase === 1 ? 'Mejores 10 participantes' :
  fase === 2 ? 'Finalistas — Top 3'       :
               'Podio Final';

  return (
    <div style={styles.root}>

      {/* ── Header ── */}
      <div style={styles.header}>

        <div style={styles.liveBadge}>
          <span style={styles.liveDot} />
          <span style={styles.liveLabel}>En vivo</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
            <Image src={require('@assets/images/uvegActualizado.png')} width="130" alt="uveg" />
            <Image src={require('@assets/images/logo-gc-horizontal.png')} width="130" alt="Global click" />
          </div>
          {/* Indicador de fase */}
          <div style={styles.faseIndicador}>
            {[1, 2, 3].map(f => (
                <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <div style={{
                    ...styles.fasePaso,
                    background: fase >= f ? '#ff9900' : 'rgba(255,255,255,0.12)',
                    color:      fase >= f ? '#00152a' : 'rgba(255,255,255,0.3)',
                    }}>
                    {f}
                    </div>
                    <span style={{
                    fontSize: 10,
                    color: fase >= f ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.25)',
                    fontWeight: fase === f ? 700 : 400,
                    }}>
                    {f === 1 ? 'Clasificatoria (20)' : f === 2 ? 'Semifinal (10)' : 'Gran Final (3)'}
                    </span>
                    {f < 3 && <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: 12, margin: '0 4px' }}>→</span>}
                </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={styles.usersBadge}>
                <span style={styles.usersCount}>{usuariosActivos}</span>
                <span style={styles.usersLabel}>activos</span>
            </div>

            {/* Botón Calificar (feed con suficientes mensajes) */}
            {vista === 'feed' && puedeCalificar && (
                <button onClick={handleCalificar} style={styles.btnCalificar}>
                    <FontAwesomeIcon icon={faTrophy} style={{ marginRight: 7 }} />
                    Calificar
                </button>
            )}

            {/* En resultados de fase 1 → avanza a fase 2 */}
            {vista === 'resultados' && fase === 1 && (
                <button onClick={handleSiguienteFase} style={styles.btnSiguiente}>
                    Fase 2 →
                </button>
            )}

            {/* En resultados de fase 2 → avanza a fase 3 */}
            {vista === 'resultados' && fase === 2 && (
                <button onClick={handleSiguienteFase} style={styles.btnSiguiente}>
                    Final →
                </button>
            )}
        </div>

      </div>

      {/* ── Vista: Feed ── */}
      {vista === 'feed' && (
        <div ref={feedRef} style={styles.feed}>

          {mensajes.length === 0 ? (
            <div style={{ ...styles.empty, gridColumn: '1 / -1' }}>
              <FontAwesomeIcon icon={faWifi} size="2x" color="rgba(255,255,255,0.2)" />
              <span style={styles.emptyText}>
                {fase === 1 && 'Esperando participantes de la fase clasificatoria…'}
                {fase === 2 && 'Esperando a los 10 clasificados para la final…'}
                {fase === 3 && 'Esperando la prueba decisiva de los 3 finalistas…'}
              </span>
            </div>
          ) : (
            mensajes.map((mensaje) => (
              <div key={mensaje.id} style={styles.messageCard}>
                <div>
                  <h4 style={styles.cardNombre}>{mensaje.nombre}</h4>
                  <div style={styles.cardStat}>⚡ {mensaje.ppm} palabras/min</div>
                  <div style={styles.cardStat}>🧠 {mensaje.comprension}% comprensión</div>
                  <div style={{ ...styles.cardStat, color: 'rgba(255,153,0,0.8)', marginTop: 4, fontSize: 12 }}>
                    IEL: {calcularIEL(mensaje.ppm, mensaje.comprension).toFixed(1)}
                  </div>
                </div>
                <div style={styles.liveBadgeComplete}>
                  <span style={styles.liveDotComplete} />
                  <span style={styles.liveLabelComplete}>Completado</span>
                </div>
              </div>
            ))
          )}

          {/* Banner de desbloqueo */}
          {puedeCalificar && (
            <div style={{ ...styles.unlockBanner, gridColumn: '1 / -1' }}>
              <FontAwesomeIcon icon={faTrophy} style={{ color: '#ff9900', marginRight: 8 }} />
              <span>
                {fase === 1 && '¡20 participantes registrados! Puedes obtener los 10 mejores.'}
                {fase === 2 && '¡10 finalistas registrados! Puedes obtener el Top 3.'}
                {fase === 3 && '¡Los 3 finalistas completaron la prueba! Puedes definir el podio.'}
              </span>
            </div>
          )}

          {/* Progreso */}
          <div style={{ ...styles.progresoBarra, gridColumn: '1 / -1' }}>
            <div style={{
              ...styles.progresoRelleno,
              width: `${Math.min((mensajes.length / META) * 100, 100)}%`,
            }} />
          </div>
          <div style={{ ...styles.progresoLabel, gridColumn: '1 / -1' }}>
            {mensajes.length} / {META} participantes
          </div>

        </div>
      )}

      {/* ── Vista: Resultados ── */}
      {vista === 'resultados' && (
        <div style={styles.feed}>

          <div style={styles.top10Header}>
            <FontAwesomeIcon icon={faTrophy} style={{ color: '#ff9900', fontSize: 22 }} />
            <span style={styles.top10Title}>{tituloResultados}</span>
          </div>

          {ranking.map((p, idx) => {
            const iel = calcularIEL(p.ppm, p.comprension).toFixed(1);
            const esMedalla = (fase === 2 || fase === 3) && idx < 3;  

            return (
              <div
                key={p.id}
                style={{
                  ...styles.top10Card,
                  borderLeft: `4px solid ${esMedalla ? medalColor[idx] : 'rgba(255,153,0,0.25)'}`,
                  background: esMedalla
                    ? `rgba(${idx === 0 ? '255,215,0' : idx === 1 ? '192,192,192' : '205,127,50'},0.07)`
                    : 'rgba(255,255,255,0.04)',
                }}
              >
                <div style={{
                  ...styles.top10Pos,
                  color: esMedalla ? medalColor[idx] : 'rgba(255,255,255,0.35)',
                }}>
                  {esMedalla ? medalLabel[idx] : `#${idx + 1}`}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={styles.top10Nombre}>{p.nombre}</div>
                  <div style={styles.top10Stats}>
                    ⚡ {p.ppm} ppm &nbsp;·&nbsp; 🧠 {p.comprension}%
                  </div>
                </div>

                <div style={styles.top10Puntaje}>
                  <span style={{ fontSize: 18, fontWeight: 700, color: '#ff9900' }}>{iel}</span>
                  <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 1 }}>IEL</span>
                </div>
              </div>
            );
          })}

        </div>
      )}

      {/* ── Footer ── */}
      <div style={styles.footer}>
        <div style={{ ...styles.wsDot, background: wsStatus === 'open' ? '#22c55e' : 'rgba(255,255,255,0.25)' }} />
        <span style={styles.wsLabel}>{statusLabel}</span>
        <span style={styles.msgCount}>
          {mensajes.length} / {META} {mensajes.length === 1 ? 'participante' : 'participantes'} · Fase {fase} {fase === 3 ? '— Gran Final' : ''}
        </span>
      </div>

    </div>
  );
};

const styles = {
  root: {
    background: '#00152a',
    overflow: 'hidden',
    fontFamily: "'Space Grotesk', system-ui, sans-serif",
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
  },
  header: {
    background: '#00152a',
    borderBottom: '1px solid rgba(255,153,0,0.25)',
    padding: '14px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  liveBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    background: 'rgba(255,153,0,0.12)',
    border: '1px solid rgba(255,153,0,0.35)',
    borderRadius: 20,
    padding: '4px 12px 4px 8px',
    flexShrink: 0,
  },
  liveDot: {
    display: 'inline-block',
    width: 8,
    height: 8,
    background: '#ff9900',
    borderRadius: '50%',
  },
  liveLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.1em',
    color: '#ff9900',
    textTransform: 'uppercase',
  },
  faseIndicador: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 2,
  },
  fasePaso: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10,
    fontWeight: 700,
    flexShrink: 0,
  },
  liveBadgeComplete: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    background: 'rgba(102,255,0,0.12)',
    border: '1px solid rgba(81,255,0,0.35)',
    borderRadius: 20,
    padding: '4px 12px 4px 8px',
    flexShrink: 0,
  },
  liveDotComplete: {
    display: 'inline-block',
    width: 8,
    height: 8,
    background: '#00ff22',
    borderRadius: '50%',
  },
  liveLabelComplete: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.1em',
    color: '#5eff00',
    textTransform: 'uppercase',
  },
  usersBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 20,
    padding: '4px 12px',
    flexShrink: 0,
  },
  usersCount: { fontSize: 13, fontWeight: 700, color: '#ffffff' },
  usersLabel: { fontSize: 11, color: 'rgba(255,255,255,0.4)', letterSpacing: '0.04em' },
  btnCalificar: {
    display: 'flex',
    alignItems: 'center',
    background: '#ff9900',
    color: '#00152a',
    border: 'none',
    borderRadius: 20,
    padding: '7px 18px',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  btnSiguiente: {
    background: 'rgba(255,153,0,0.15)',
    color: '#ff9900',
    border: '1px solid rgba(255,153,0,0.4)',
    borderRadius: 20,
    padding: '6px 16px',
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  feed: {
  flex: 1,
  overflowY: 'auto',
  padding: '12px 16px',
  display: 'grid',                                    // 👈 de flex a grid
  gridTemplateColumns: 'repeat(4, 1fr)',              // 👈 4 columnas iguales
  gridAutoRows: 'min-content',                        // 👈 filas ajustadas al contenido
  gap: 12,
  alignContent: 'start',                              // 👈 cards pegados arriba
},
  empty: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 32,
  },
  emptyText: { fontSize: 14, color: 'rgba(255,255,255,0.2)', textAlign: 'center' },
  messageCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#011122',
    border: '1px solid rgba(255,153,0,0.15)',
    borderLeft: '3px solid #ff9900',
    borderRadius: 10,
    padding: '12px 16px',
  },
  cardNombre: { color: '#ffffff', fontWeight: 700, margin: '0 0 4px', fontSize: 15 },
  cardStat:   { color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 2 },
  unlockBanner: {
    display: 'flex',
    alignItems: 'center',
    background: 'rgba(255,153,0,0.1)',
    border: '1px solid rgba(255,153,0,0.3)',
    borderRadius: 10,
    padding: '12px 16px',
    color: 'rgba(255,255,255,0.8)',
    fontSize: 13,
    fontWeight: 500,
    marginTop: 4,
  },
  progresoBarra: {
    height: 3,
    background: 'rgba(255,255,255,0.08)',
    borderRadius: 2,
    overflow: 'hidden',
    marginTop: 8,
  },
  progresoRelleno: {
    height: '100%',
    background: '#ff9900',
    borderRadius: 2,
    transition: 'width 0.4s ease',
  },
  progresoLabel: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.25)',
    textAlign: 'right',
    marginTop: 4,
  },
  top10Header: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    paddingBottom: 12,
    borderBottom: '1px solid rgba(255,153,0,0.2)',
    marginBottom: 4,
  },
  top10Title: {
    fontSize: 18,
    fontWeight: 700,
    color: '#ffffff',
    letterSpacing: '-0.01em',
  },
  top10Card: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    borderRadius: 10,
    padding: '12px 16px',
    border: '1px solid transparent',
  },
  top10Pos: {
    fontSize: 20,
    fontWeight: 700,
    minWidth: 36,
    textAlign: 'center',
  },
  top10Nombre: {
    fontSize: 15,
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: 3,
  },
  top10Stats: { fontSize: 12, color: 'rgba(255,255,255,0.5)' },
  top10Puntaje: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    minWidth: 48,
  },
  footer: {
    background: 'rgba(255,255,255,0.03)',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '9px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  wsDot:    { width: 7, height: 7, borderRadius: '50%', flexShrink: 0 },
  wsLabel:  { fontSize: 11, color: 'rgba(255,255,255,0.3)', flex: 1, letterSpacing: '0.03em' },
  msgCount: { fontSize: 11, color: 'rgba(255,153,0,0.5)' },
};

export default PanelFinalCompetenciaLectura;